export default {
  Favored: {
    LIMIT: 6
  }
};
